import moment from "moment";
import { validations } from "../constants";

/**
 * @description - Convert date to MM/DD/YYYY (12/30/1997) formate
 * @param {string} date
 * @returns {string} string
 */

export const convartDate = (date = new Date()) => {
   const nDate = new Date(date);
   return (
      (nDate.getMonth() > 8
         ? nDate.getMonth() + 1
         : "0" + (nDate.getMonth() + 1)) +
      "/" +
      (nDate.getDate() > 9 ? nDate.getDate() : "0" + nDate.getDate()) +
      "/" +
      nDate.getFullYear()
   );
};
export const weekArr = [
   { 1: "WEEK ONE" },
   { 2: "WEEK TWO" },
   { 3: "WEEK THREE" },
   { 4: "WEEK FOUR" },
   { 5: "WEEK FIVE" },
   { 6: "WEEK SIX" },
   { 7: "WEEK SEVEN" },
   { 8: "WEEK EIGHT" },
];
export const convertWeekStrtoNum = (data) => {
   let final;
   weekArr.filter((d) => {
      if (Object.keys(d) == data) {
         final = d[data];
      }
   });
   return final;
};

export const delay = (cb, time = 1000) => {
   let timer = setTimeout(() => {
      cb();
      clearTimeout(timer);
   }, time)

   return timer;
};

export const reoccur = (cb, time = 1000) => {
   let timer = setInterval(() => {
      cb();
   }, time)

   return timer;
};

export const getGroupWeekDates = (startDate) => {
   const days = ["", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

   let currDate = null;

   startDate = new Date(startDate);
   currDate = new Date();

   const sDay = moment(startDate).format("ddd");
   const cDay = moment(currDate).format("ddd");

   const sIndex = days.indexOf(sDay);
   const cIndex = days.indexOf(cDay);

   let back = 0;

   if (sIndex <= cIndex) {
      back = cIndex - sIndex;
   } else if (sIndex > cIndex) {
      back = sIndex - cIndex;
   }

   let dates = [];

   currDate = moment(currDate);

   dates.push(currDate.subtract(back, back === 1 ? "day" : "days").format("YYYY-MM-DD"));
   for (let x = 0; x < 6; x++) {
      dates.push(currDate.add(1, "day").format("YYYY-MM-DD"));
   }

   return dates;
};

export const isValidEmail = (email) => {
   return validations.emailRegex.test(email);
};

export const isValidNumber = (number) => {
   return number.length === 10;
};

export const formPhoneNumber = (mn) => {

   let formed = [];

   for (let x = 0; x < 10; x++) {
      if (x === 0) formed.push("(");
      else if (x === 3) formed.push(") ");
      else if (x === 6) formed.push("-");

      formed.push(mn[x]);
   }

   return formed.join("");

};

export const generateRandomNumber = (max) => {
   return Math.floor(Math.random() * max);
}

export const removeDuplicates = (array, keys = []) => {
   if (!keys.length) {
      // Handle arrays of primitive values
      return [...new Set(array.filter(item => item != null && item !== ''))];
   }

   // Handle arrays of objects with specified keys
   const map = new Map();
   array.forEach(item => {
      const compositeKey = keys.map(key => item[key]).join('|');
      map.set(compositeKey, item);
   });
   return [...map.values()];
};

export const removeItemInArray = (list, toRemove, keys = []) => {
   if (!Array.isArray(list)) return list;

   if (!Array.isArray(toRemove)) {
      toRemove = [toRemove];
   }

   if (typeof toRemove[0] !== 'object') {
      // Handle arrays of primitive values
      if (true) {
         return list.filter(item => !toRemove.includes(item));
      } else {
         return list.filter(item => !toRemove.includes(item));
      }
   }

   // Handle arrays of objects with specified keys
   const toRemoveKeys = new Set(toRemove.map(item => keys.map(key => item[key]).join('|')));

   return list.filter(item => {
      const itemKey = keys.map(key => item[key]).join('|');
      return !toRemoveKeys.has(itemKey);
   });
};

export const swapArrayElements = (arr, index1, index2) => {

   const isValidIndex = (index) => index >= 0 && index < arr.length;

   if (!isValidIndex(index1) || !isValidIndex(index2)) {
      console.error("Invalid indices provided. Indices must be within array bounds.");
      return arr;
   }

   // Swap elements using destructuring
   [arr[index1], arr[index2]] = [arr[index2], arr[index1]];

   return arr;
}

export const parseJSON = (content) => {

   let parsed = null;
   try {
      parsed = JSON.parse(content);
   } catch (error) {

      try {
         // let fixedJson = content.replace(/'/g, '"');
         let fixedJson = content.replace(/(\w+):/g, '"$1":');
         fixedJson = fixedJson.replace(/,\s*([\]}])/g, '$1');

         parsed = JSON.parse(fixedJson);
      } catch (error2) {
         parsed = null;
      }

   }

   return parsed;
}

export const padNumber = (num, length = 2) => num ? String(num).padStart(length, '0') : num;
